import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";

import Button from "@client/components/ui/Button";
import StatusImage from "@client/components/ui/StatusImage";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-top: 32px;
`;
const Status = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;
const StatusLabel = styled.div`
  font-size: 18px;
  margin-top: 64px;
`;
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin: 48px 32px 32px 32px;
`;
type Props = {
  onRequestClose: () => void;
};

@observer
class LicenceModalStatus extends React.Component<Props> {
  render() {
    return (
      <Wrapper>
        <Status>
          <StatusImage status="success" />
          <StatusLabel>Licence was succesfully sent</StatusLabel>
        </Status>
        <Buttons>
          <Button onClick={this.props.onRequestClose}>Close</Button>
        </Buttons>
      </Wrapper>
    );
  }
}

export default LicenceModalStatus;
